// extracted by mini-css-extract-plugin
export default {"panel":"TabPanel_panel__0rM2O","hidden":"TabPanel_hidden__r4ZkC"};